import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import { apiSupportStaffClientList } from '@/entities/support-staff/modules/api/support-staff';

export const useSupportStaffClient = (enabled = true) =>
  useFetch({
    api: apiSupportStaffClientList,
    keywords: queryKeys.supportStaff.all,
    enabled,
    staleTime: 60_000,
  });
